<template>
  <div class="size-guide-wrapper">
    <img src="../../assets/imgs/sizeguide/size_guide-header.png" />
    <img src="../../assets/imgs/sizeguide/size_1_0.png" />
    <img src="../../assets/imgs/sizeguide/size_1_1.png" />
    <img src="../../assets/imgs/sizeguide/size_1_2.png" />
    <img src="../../assets/imgs/sizeguide/size_1_3.png" />
    <img src="../../assets/imgs/sizeguide/size_1_4.png" />
    <img src="../../assets/imgs/sizeguide/size_2_1.png" />
    <img src="../../assets/imgs/sizeguide/size_2_2.png" />
    <img src="../../assets/imgs/sizeguide/size_2_3.png" />
    <img src="../../assets/imgs/sizeguide/size_2_4.png" />
    <img src="../../assets/imgs/sizeguide/size_2_5.png" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.size-guide-wrapper {
  text-align: center;
  img { width: 100%; max-width: 790px; height: auto; margin: 0 auto; }
}
</style>